import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type ImplementSectionProps = {
  className?: string;
  setPosition?: 'top' | 'bottom';
};

export const ImplementSection: React.FC<ImplementSectionProps> = ({
  className,
  setPosition
}) => {
  return (
    <section
      className={className}
      css={css`
        position: relative;
        overflow: hidden;
        padding: ${ setPosition === 'top'
          ? "64px 20px 64px"
          : setPosition === 'bottom'
          ? "120px 20px 120px"
          : "120px 20px 120px" };
          
        background: ${ setPosition === 'top'
          ? "transparent"
          : setPosition === 'bottom'
          ? "transparent linear-gradient(180deg, #F0FCFB 0%, #FFF 136px, #FFF 100%) 0% 0% no-repeat padding-box"
          : "transparent" };
      `}
      
    >
      { setPosition === 'bottom' && 
        <div
          css={css`
            position: absolute;
            bottom: -100px;
            left: -200px;
            width: 400px;
            height: 400px;
            border: 100px solid #00B3A7;
            border-radius: 200px;
            opacity: 0.08;
          `}
        ></div>
      }
      { setPosition === 'bottom' && 
        <div
          css={css`
            position: absolute;
            bottom: -225px;
            right: -225px;
            width: 450px;
            height: 450px;
            border-radius: 250px;
            border: 110px solid #00B3A7;
            opacity: 0.04;
          `}
        ></div>
      }
      
      <h2
        css={css`
          position: relative;
          display: flex;
          justify-content: center;
          gap: 5px;
          align-items: flex-end;
          font: normal normal bold 14px/21px Noto Sans JP;
          text-align: center;
          
          @media ${getScreen('pc')} {
            display: flex;
            font: normal normal bold 20px/29px Noto Sans JP;
          }
          
          
          &::before,
          &::after {
            content: '';
            position: relative;
            top: -3px;
            display: block;
            width: 2px;
            height: 28px;
            background: #00b3a7;
            border-radius: 9999px;
            transform: rotate(-45deg);
            transform-origin: right bottom;

            @media ${getScreen('pc')} {
              top: -3px;
              height: 28px;
              transform: rotate(-45deg);
            }
          }

          &::after {
            transform: rotate(45deg);
            transform-origin: left bottom;
            
            @media ${getScreen('pc')} {
              transform: rotate(45deg);
            }
          }
          
          
          strong {
            color: #00B3A7;
          }
        `}
      >
        Uniforceは<strong>多くの企業様</strong>に導入いただいています
      </h2>
      <ul
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
          margin: auto;
          margin-top: 20px;
          padding: 0 20px;

          @media ${getScreen('pc')} {
            gap: 20px;
            margin-top: 0px;
          }
          
          li {
            width: calc(33.3% - 10px);
            text-align: center;
            
            img {
              width: 100%;
              @media ${getScreen('pc')} {
                width: revert-layer;
              }
            }
            
            @media ${getScreen('pc')} {
              width: auto;
            }
          }
          
        `}
      >
          <li>
            <img src={withPrefix('/images/implement-logo_ippo.png')} alt="ippo" width={130} />
          </li>
          <li>
            <img src={withPrefix('/images/implement-logo_asteeda.png')} alt="ASTEEDA" width={130} />
          </li>
          <li>
            <img src={withPrefix('/images/implement-logo_fufu.png')} alt="fufu" width={130} />
          </li>
          <li>
            <img src={withPrefix('/images/implement-logo_triorb.png')} alt="Triorb" width={130} />
          </li>
          <li>
            <img src={withPrefix('/images/implement-logo_timecrowd.png')} alt="TimeCrowd" width={130} />
          </li>
          <li>
            <img src={withPrefix('/images/implement-logo_unitedwill.png')} alt="United Will" width={130} />
          </li>
      </ul>
    </section>
  );
};
